import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Array to store GSTR1 report data (categories with counts, taxes, etc.)
  loading: false,
  error: null,
};

const gstr1ReportSlice = createSlice({
  name: "Gstr1Report",
  initialState,
  reducers: {
    Gstr1ReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    Gstr1ReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // Payload contains the processed GSTR1 report data
    },
    Gstr1ReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  Gstr1ReportRequest,
  Gstr1ReportSuccess,
  Gstr1ReportFailure,
} = gstr1ReportSlice.actions;

export default gstr1ReportSlice.reducer;

